import copy from 'clipboard-copy';
import React, { ReactNode } from 'react';
import { addToast } from 'common/components/toast-area/toast-manager';
import { ToastType } from 'common/components/toast/types';
import { SvgIconReact } from 'iron/common/components/svg-icon';
import { TagReact } from 'common/components/tag';
import { TagSize, TagTheme } from 'common/components/tag/types';
import { useFeatureFlagStore } from 'apps/feature-flags/src/store';
import { SHOULD_SHOW_SERVING_METHOD } from 'apps/feature-flags/src/constants';
import { useTranslation } from 'common/i18n/hooks';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { useFeatureFlagPageContext } from 'iron/apps/feature-flags/src/components/context';
import styles from './index.module.styl';

// Hide tags from the page configuration until we make it editable
const SHOULD_SHOW_TAGS = false;
export function FeatureFlagPageConfiguration() {
  var _flag$status, _flag$context, _flag$serving_method, _flag$tags;
  const i18n = useTranslation();
  const flag = useFeatureFlagStore(store => store.currentFeatureFlag);
  const setEditModalOpen = useFeatureFlagStore(store => store.setEditModalOpen);
  const {
    canEdit
  } = useFeatureFlagPageContext();
  const handleCopyClick = async () => {
    if (flag !== null && flag !== void 0 && flag.key) {
      await copy(flag.key);
      addToast({
        type: ToastType.SUCCESS,
        message: i18n.t("components.copy-to-clipboard.copied")
      });
    }
  };
  return <aside className={styles.configuration} data-sentry-component="FeatureFlagPageConfiguration" data-sentry-source-file="index.tsx">
      <ConfigItem title={i18n.t("feature-flags.page.config.key")} data-sentry-element="ConfigItem" data-sentry-source-file="index.tsx">
        <span className={styles.key}>{flag === null || flag === void 0 ? void 0 : flag.key}</span>
        <SvgIconReact className={styles.copyIcon} icon='copy' height='8px' onClick={handleCopyClick} data-sentry-element="SvgIconReact" data-sentry-source-file="index.tsx" />
      </ConfigItem>
      <ConfigItem title={i18n.t("feature-flags.page.config.status")} data-sentry-element="ConfigItem" data-sentry-source-file="index.tsx">
        <TagReact className={styles.tag} theme={TagTheme.Secondary} size={TagSize.Small} tagName={i18n.t("feature-flags.status.".concat((_flag$status = flag === null || flag === void 0 ? void 0 : flag.status) !== null && _flag$status !== void 0 ? _flag$status : "disabled"))} data-sentry-element="TagReact" data-sentry-source-file="index.tsx" />
      </ConfigItem>
      <ConfigItem title={i18n.t("feature-flags.page.config.context")} data-sentry-element="ConfigItem" data-sentry-source-file="index.tsx">
        <TagReact className={styles.tag} theme={TagTheme.Secondary} size={TagSize.Small} tagName={(_flag$context = flag === null || flag === void 0 ? void 0 : flag.context) !== null && _flag$context !== void 0 ? _flag$context : "distinct_id"} data-sentry-element="TagReact" data-sentry-source-file="index.tsx" />
      </ConfigItem>
      {SHOULD_SHOW_SERVING_METHOD && <ConfigItem title={i18n.t("feature-flags.page.config.serving-method")}>
          <TagReact className={styles.tag} theme={TagTheme.Secondary} size={TagSize.Small} tagName={i18n.t("feature-flags.serving-method.".concat((_flag$serving_method = flag === null || flag === void 0 ? void 0 : flag.serving_method) !== null && _flag$serving_method !== void 0 ? _flag$serving_method : "client"))} />
        </ConfigItem>}
      {SHOULD_SHOW_TAGS && <ConfigItem title={i18n.t("feature-flags.page.config.tags")}>
          <div className={styles.tagContainer}>
            {((_flag$tags = flag === null || flag === void 0 ? void 0 : flag.tags) !== null && _flag$tags !== void 0 ? _flag$tags : []).map((tag, index) => <TagReact className={styles.tag} key={index} theme={TagTheme.Secondary} size={TagSize.Small} tagName={tag} />)}
          </div>
        </ConfigItem>}
      <div className={styles.configActions}>
        <ButtonReact disabled={!canEdit} theme={ButtonTheme.Secondary} onClick={() => setEditModalOpen(true)} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
          {i18n.t("feature-flags.page.config.edit-settings")}
        </ButtonReact>
      </div>
    </aside>;
}
interface ConfigItemProps {
  title: string;
  children: ReactNode;
}
export function ConfigItem(_ref: ConfigItemProps) {
  let {
    title,
    children
  }: ConfigItemProps = _ref;
  return <div className={styles.configItem} data-sentry-component="ConfigItem" data-sentry-source-file="index.tsx">
      <p className={styles.configItemTitle}>{title}</p>
      <div className={styles.configItemContent}>{children}</div>
    </div>;
}